<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      ref="table"
      single-expand
      >
      <template v-slot:foot="{ total }">
        <td :colspan="item.headers.length" :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
          <div class="my-3 mx-4">
            出勤薪资：<span :class="`${$isMobile ? 'size-20': 'size-27'} blue--text font-family-Impact`">{{total === null ? 0 : total.workSalary}}</span>&nbsp;
            提成薪资：<span :class="`${$isMobile ? 'size-20': 'size-27'} teal--text font-family-Impact`">{{total === null ? 0 : total.commissionSalary}}</span>&nbsp;<br v-if="$isMobile">
            社保扣除：<span :class="`${$isMobile ? 'size-20': 'size-27'} amber--text font-family-Impact`">{{total === null ? 0 : total.socialSecurityDeduct }}</span>&nbsp;<br v-if="$isMobile">
            个税扣除：<span :class="`${$isMobile ? 'size-20': 'size-27'} orange--text font-family-Impact`">{{total === null ? 0 : total.selfTaxDeduct }}</span>&nbsp;<br v-if="$isMobile">
            应发薪资：<span :class="`${$isMobile ? 'size-20': 'size-27'} indigo--text font-family-Impact`">{{total === null ? 0 : total.shouldSalary}}</span>&nbsp;<br v-if="$isMobile">
            实发薪资：<span :class="`${$isMobile ? 'size-20': 'size-27'} green--text font-family-Impact`">{{total === null ? 0 : total.actualSalary}}</span>&nbsp;
          </div>
        </td>
      </template>
      <template v-slot:actions>
        <v-btn depressed dark :small='$isMobile' color="cyan" @click="importModal = { show: true }" class="mx-1 px-2">
          <v-icon size="20" dark>mdi-file-check-outline</v-icon>导入
        </v-btn>
      </template>
      <template v-slot:condition>
        <v-col cols="12" md='2' class="pl-0">
          <base-marerial-user-select  @on-change="loadData" outlined dense hide-details='auto' v-model="item.params.uids"></base-marerial-user-select>
        </v-col>
        <v-col cols="12" md='2' class="pl-0">
           <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.year'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2' class="pl-0">
           <v-select-search
            hide-details
            outlined dense
            label="月份选择"
            :data='monthItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.month'>
          </v-select-search>
        </v-col>
      </template>
    </base-material-table>
    <import-view :item='importModal' @on-load-data='loadData'></import-view>
    <clock-in :item="clockInModal"></clock-in>
  </v-container>
</template>

<script>
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import ClockIn from '@/views/pages/pc/dashboard/personal/components/ClockInDetail.vue'
  import ImportView from './components/Import'

  export default {
    name: 'OfficeSalarys',
    components: {
      ImportView,
      VSelectSearch,
      ClockIn
    },
    data() {
      return {
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        clockInModal: { show: false },
        importModal: { show: false, data: {} },
        item: {
          mobile: true,
          total: true,
          path: 'office/salary/list',
          topButtons: [
            { event: 'search', show: true }
          ],
          params: {
            uids: [],
            year: Number(this.$moment().format('YYYY')),
            month: Number(this.$moment().format('MM'))
          },
          headers: [
            {
              text: '头像',
              align: 'center',
              divider: true,
              sortable: false,
              value: 'userInfo.avatar',
              width: 90,
              mobile: true,
              avatar: (val) => val
            },
            {
              text: '姓名',
              align: 'center',
              divider: true,
              value: 'userInfo.name',
              width: 100,
              sortable: false,
              class: 'fixed-left',
              cellClass: 'fixed-left',
            },
            {
              text: '状态',
              align: 'center',
              divider: true,
              value: 'userInfo.workState',
              chip: {
                color: (val) => (val === 1 ? 'green' : 'grey'),
                formatter: (val, item) => item.userInfo.workStateVal
              },
              width: 100,
              sortable: false,
              search: {
                mobile: true,
                type: 'select',
                secKey: 'workState',
                options: () => [
                  { label: '离职', value: 0 },
                  { label: '在职', value: 1 },
                ]
              }
            },
            {
              text: '底薪',
              align: 'center',
              divider: true,
              value: 'baseSalary',
              width: 100,
              sortable: false
            },
            {
              text: '出勤天数',
              align: 'center',
              divider: true,
              value: 'actions',
              width: 100,
              sortable: false,
              actions: [
                {
                  dtext: (row) => `${row.realWorkDay}天`,
                  color: 'primary',
                  onClick: (row) => this.clockInModal = { show: true, data: { month: this.item.params.month, year: this.item.params.year, uid: row.uid } },
                  disable: () => false
                }
              ]
            },
            {
              text: '出勤工资',
              align: 'center',
              divider: true,
              value: 'workSalary',
              width: 120,
              sortable: false
            },
            {
              text: '年资',
              align: 'center',
              divider: true,
              value: 'yearSalary',
              width: 100,
              sortable: false
            },
            {
              text: '绩效津贴',
              align: 'center',
              divider: true,
              value: 'profitSalary',
              width: 100,
              sortable: false
            },
            {
              text: '个人提成',
              align: 'center',
              divider: true,
              value: 'commissionSalary',
              width: 120,
              sortable: false
            },
            {
              text: '到账流水提成',
              align: 'center',
              divider: true,
              value: 'flowingCommissionSalary',
              width: 130,
              sortable: false
            },
            {
              text: '迟到扣除',
              align: 'center',
              divider: true,
              value: 'lateDeduct',
              width: 140,
              sortable: false
            },
            {
              text: '缺卡扣除',
              align: 'center',
              divider: true,
              value: 'missingDeduct',
              width: 140,
              sortable: false
            },
            {
              text: '请假扣除',
              align: 'center',
              divider: true,
              value: 'leaveDeduct',
              width: 120,
              sortable: false
            },
            {
              text: '汇报扣除',
              align: 'center',
              divider: true,
              value: 'reportDeduct',
              width: 120,
              sortable: false
            },
            {
              text: '电话考核扣除',
              align: 'center',
              divider: true,
              value: 'callDeduct',
              width: 140,
              sortable: false
            },
            {
              text: '乐捐扣除',
              align: 'center',
              divider: true,
              value: 'otherDeduct',
              width: 120,
              sortable: false
            },
            {
              text: '餐补',
              align: 'center',
              divider: true,
              value: 'otherWelfare',
              width: 120,
              sortable: false
            },
            {
              text: '应发工资',
              align: 'center',
              divider: true,
              value: 'shouldSalary',
              width: 120,
              sortable: false
            },
            {
              text: '社保扣除',
              align: 'center',
              divider: true,
              value: 'socialSecurityDeduct',
              width: 120,
              sortable: false
            },
            {
              text: '个税扣除',
              align: 'center',
              value: 'selfTaxDeduct',
              width: 120,
              sortable: false
            },
            {
              text: '实发工资',
              align: 'center',
              value: 'actualSalary',
              width: 100,
              sortable: false,
              class: 'fixed-right',
              cellClass: 'fixed-right',
            }
          ]
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>
